//金额数字转大写方法
export function computeLen(number) {
  let ret = ''
  if (number !== '' && number != null && number !== '0') {
    let unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
    let str = ''
    number += '00'
    const point = number.indexOf('.')
    if (point >= 0) {
      number = number.substring(0, point) + number.substr(point + 1, 2)
    }
    unit = unit.substr(unit.length - number.length)
    for (let i = 0; i < number.length; i++) {
      str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
    }
    ret = str
      .replace(/零(仟|佰|拾|角)/g, '零')
      .replace(/(零)+/g, '零')
      .replace(/零(万|亿|元)/g, '$1')
      .replace(/(亿)万|(拾)/g, '$1$2')
      .replace(/^元零?|零分/g, '')
      .replace(/元$/g, '元')
  }
  return ret
}
//部门转树状结构
export function buildtree(list, arr, parentId) {
  list.forEach(item => {
    if (item.parent_id === parentId) {
      var childrens = {
        companyDeptName: item.companyDeptName,
        dept_id: item.dept_id,
        dept_name: item.dept_name,
        childrens: [],
        parent_id: item.parent_id,
        id: item.id,
        month1: item.month1,
        month2: item.month2,
        month3: item.month3,
        month4: item.month4,
        month5: item.month5,
        month6: item.month6,
        month7: item.month7,
        month8: item.month8,
        month9: item.month9,
        month10: item.month10,
        month11: item.month11,
        month12: item.month12,
        subsetIds: item.subsetIds,
        subsetObjects: item.subsetObjects,
        // leader: item.leader
      }
      buildtree(list, childrens.childrens, item.dept_id)
      arr.push(childrens)
    }
  })
  return arr
}
//获取平铺结构
export function buildFlatten(tree){
  let arr = [];
  for (let i = 0, l = tree.length; i < l; i++) {
    arr.push(tree[i]);
    if (tree[i].childrens && tree[i].childrens.length > 0) {
      arr = arr.concat(buildFlatten(tree[i].childrens));
    }
  }
  return arr;
};